/**
 * O estado da malha municipal da UF em foco (§9.2; FB-04): escritor único a ligação do mapa (`features/map/munBinding.ts`). Fica à parte, só com o
 * sinal, para o chunk `index` (o cartão da UF, que mostra "Clique num município" só com a malha desenhada, AC-8.2-07)
 * ler o estado sem trazer a ligação, a busca da malha nem o decodificador.
 */
import { signal } from '@preact/signals';
import type { MunMeshStatus } from '../features/map/munBinding';
import type { RouteState, UfCode } from '../model/types';

export type { MunMeshStatus };

/** O estado da malha da UF em foco; null sem UF em foco (ou sem a ligação, como no site sem `municipal_map`). */
export const munMesh = signal<MunMeshStatus>(null);

/** A UF cujos municípios a página quer ver: a da rota (UF ou município), só na aba Presidente. */
export function municipalFocus(r: Pick<RouteState, 'office' | 'place'>): UfCode | null {
  if (r.office !== 'president') return null;
  return r.place.kind === 'uf' || r.place.kind === 'municipality' ? r.place.uf : null;
}

/** O Brasil inteiro por município (regra de 31/10): a regra mora em `model/scene.ts`. */
export { municipalNational } from '../model/scene';
